/* tslint:disable */
/* eslint-disable */
/**
 * OpenShifts.WebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AccrualResponse } from '../api-models';
// @ts-ignore
import { BaseResponse } from '../api-models';
// @ts-ignore
import { BaseResponseOfGetEmployeePositionsWithCoverage } from '../api-models';
// @ts-ignore
import { BaseResponseOfListOfCreateAssignmentDto } from '../api-models';
// @ts-ignore
import { BaseResponseOfListOfEmployeeDetailsResponse } from '../api-models';
// @ts-ignore
import { BaseResponseOfListOfViewEmployerDto } from '../api-models';
// @ts-ignore
import { BaseResponseOfPageModelOfEmployeeDetailsResponse } from '../api-models';
// @ts-ignore
import { BaseResponseOfValidateEmployeeSchedulePatternDTO } from '../api-models';
// @ts-ignore
import { BaseResponseOfViewEmployeeSchedulePatternDto } from '../api-models';
// @ts-ignore
import { BaseResponseOfViewEmployerDto } from '../api-models';
// @ts-ignore
import { SchedulerTabsVisibilityResponse } from '../api-models';
// @ts-ignore
import { UpdateEmployeeLaborLevelsInNewSchedulerRequest } from '../api-models';
// @ts-ignore
import { UpdateEmployeeSchedulePatternDto } from '../api-models';
// @ts-ignore
import { UpdateEmployerDto } from '../api-models';
// @ts-ignore
import { ViewEmployeeSchedulePatternDto } from '../api-models';
/**
 * HrApi - axios parameter creator
 * @export
 */
export const HrApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Shows Accruals in FE friendly format
         * @param {number} [employeeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hrAccrualsGet: async (employeeId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/hr/accruals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hrAllEmployeesLaborLevelsPut: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/hr/all-employees-labor-levels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Disables an employee in the scheduler system based on the provided employee ID.
         * @param {number} employeeId The ID of the employee to disable in the scheduler.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hrEmployeeDetailsEmployeeIdDisablePut: async (employeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('hrEmployeeDetailsEmployeeIdDisablePut', 'employeeId', employeeId)
            const localVarPath = `/hr/employee-details/{employeeId}/disable`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Enables the employee in the scheduler by setting their status to active.
         * @param {number} employeeId The ID of the employee to enable.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hrEmployeeDetailsEmployeeIdEnablePut: async (employeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('hrEmployeeDetailsEmployeeIdEnablePut', 'employeeId', employeeId)
            const localVarPath = `/hr/employee-details/{employeeId}/enable`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves the scheduler status of a specific employee.
         * @param {number} employeeId The unique identifier of the employee.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        hrEmployeeDetailsEmployeeIdStatusGet: async (employeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('hrEmployeeDetailsEmployeeIdStatusGet', 'employeeId', employeeId)
            const localVarPath = `/hr/employee-details/{employeeId}/status`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [searchParam] 
         * @param {number} [departmentId] 
         * @param {number} [facilityId] 
         * @param {number} [positionId] 
         * @param {number} [employerId] 
         * @param {number} [employeeId] 
         * @param {boolean} [hasPendingAbsenceRequests] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {boolean} [allowInactive] 
         * @param {boolean} [allowWithoutCellphone] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hrEmployeeDetailsGet: async (searchParam?: string, departmentId?: number, facilityId?: number, positionId?: number, employerId?: number, employeeId?: number, hasPendingAbsenceRequests?: boolean, pageNumber?: number, pageSize?: number, allowInactive?: boolean, allowWithoutCellphone?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/hr/employee-details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (searchParam !== undefined) {
                localVarQueryParameter['searchParam'] = searchParam;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (facilityId !== undefined) {
                localVarQueryParameter['facilityId'] = facilityId;
            }

            if (positionId !== undefined) {
                localVarQueryParameter['positionId'] = positionId;
            }

            if (employerId !== undefined) {
                localVarQueryParameter['employerId'] = employerId;
            }

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }

            if (hasPendingAbsenceRequests !== undefined) {
                localVarQueryParameter['hasPendingAbsenceRequests'] = hasPendingAbsenceRequests;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (allowInactive !== undefined) {
                localVarQueryParameter['allowInactive'] = allowInactive;
            }

            if (allowWithoutCellphone !== undefined) {
                localVarQueryParameter['allowWithoutCellphone'] = allowWithoutCellphone;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [searchParam] 
         * @param {number} [departmentId] 
         * @param {number} [facilityId] 
         * @param {number} [positionId] 
         * @param {number} [employerId] 
         * @param {number} [employeeId] 
         * @param {boolean} [hasPendingAbsenceRequests] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {boolean} [allowInactive] 
         * @param {boolean} [allowWithoutCellphone] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hrEmployeeDetailsNoPaginationGet: async (searchParam?: string, departmentId?: number, facilityId?: number, positionId?: number, employerId?: number, employeeId?: number, hasPendingAbsenceRequests?: boolean, pageNumber?: number, pageSize?: number, allowInactive?: boolean, allowWithoutCellphone?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/hr/employee-details-no-pagination`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (searchParam !== undefined) {
                localVarQueryParameter['searchParam'] = searchParam;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (facilityId !== undefined) {
                localVarQueryParameter['facilityId'] = facilityId;
            }

            if (positionId !== undefined) {
                localVarQueryParameter['positionId'] = positionId;
            }

            if (employerId !== undefined) {
                localVarQueryParameter['employerId'] = employerId;
            }

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }

            if (hasPendingAbsenceRequests !== undefined) {
                localVarQueryParameter['hasPendingAbsenceRequests'] = hasPendingAbsenceRequests;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (allowInactive !== undefined) {
                localVarQueryParameter['allowInactive'] = allowInactive;
            }

            if (allowWithoutCellphone !== undefined) {
                localVarQueryParameter['allowWithoutCellphone'] = allowWithoutCellphone;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Commits all pending scheduler changes for the specified employee.  This includes status, planned absences, and schedule patterns, and then clears the draft.
         * @param {number} employeeId The ID of the employee whose draft changes should be committed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hrEmployeeIdSavePut: async (employeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('hrEmployeeIdSavePut', 'employeeId', employeeId)
            const localVarPath = `/hr/{employeeId}/save`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Discards all pending scheduler changes for the specified employee, effectively undoing them.  This includes status, planned absences, and schedule patterns.
         * @param {number} employeeId The ID of the employee whose draft changes should be discarded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hrEmployeeIdUndoPut: async (employeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('hrEmployeeIdUndoPut', 'employeeId', employeeId)
            const localVarPath = `/hr/{employeeId}/undo`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates the employee\'s labor levels in the new scheduler based on TA system data.
         * @param {number} employeeId The PkId of the employee to update.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hrEmployeeLaborLevelsEmployeeIdPut: async (employeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('hrEmployeeLaborLevelsEmployeeIdPut', 'employeeId', employeeId)
            const localVarPath = `/hr/employee-labor-levels/{employeeId}`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hrEmployeeScheduleDisabledEmployeeIdGet: async (employeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('hrEmployeeScheduleDisabledEmployeeIdGet', 'employeeId', employeeId)
            const localVarPath = `/hr/employee-schedule/disabled/{employeeId}`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hrEmployeeScheduleEmployeeIdGet: async (employeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('hrEmployeeScheduleEmployeeIdGet', 'employeeId', employeeId)
            const localVarPath = `/hr/employee-schedule/{employeeId}`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validation API used at schedule patterns old screen
         * @param {number} employeeId 
         * @param {UpdateEmployeeSchedulePatternDto} [updateEmployeeSchedulePatternDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hrEmployeeScheduleValidateEmployeeIdPost: async (employeeId: number, updateEmployeeSchedulePatternDto?: UpdateEmployeeSchedulePatternDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('hrEmployeeScheduleValidateEmployeeIdPost', 'employeeId', employeeId)
            const localVarPath = `/hr/employee-schedule-validate/{employeeId}`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmployeeSchedulePatternDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateEmployeeLaborLevelsInNewSchedulerRequest} [updateEmployeeLaborLevelsInNewSchedulerRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hrEmployeesLaborLevelsPut: async (updateEmployeeLaborLevelsInNewSchedulerRequest?: UpdateEmployeeLaborLevelsInNewSchedulerRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/hr/employees-labor-levels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmployeeLaborLevelsInNewSchedulerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} employerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hrEmployerEmployerIdGet: async (employerId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employerId' is not null or undefined
            assertParamExists('hrEmployerEmployerIdGet', 'employerId', employerId)
            const localVarPath = `/hr/employer/{employerId}`
                .replace(`{${"employerId"}}`, encodeURIComponent(String(employerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} employerId 
         * @param {UpdateEmployerDto} [updateEmployerDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hrEmployerEmployerIdPut: async (employerId: number, updateEmployerDto?: UpdateEmployerDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employerId' is not null or undefined
            assertParamExists('hrEmployerEmployerIdPut', 'employerId', employerId)
            const localVarPath = `/hr/employer/{employerId}`
                .replace(`{${"employerId"}}`, encodeURIComponent(String(employerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmployerDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hrEmployerGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/hr/employer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [schedulePeriodId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hrFixIncorrectAssignmentsDueToFailedBuildSchedulesPost: async (schedulePeriodId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/hr/fix-incorrect-assignments-due-to-failed-build-schedules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (schedulePeriodId !== undefined) {
                localVarQueryParameter['schedulePeriodId'] = schedulePeriodId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hrPositionWithCoverageEmployeeIdGet: async (employeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('hrPositionWithCoverageEmployeeIdGet', 'employeeId', employeeId)
            const localVarPath = `/hr/position-with-coverage/{employeeId}`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Removes employee from scheduler only
         * @param {number} employeeAdditionalInfoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hrSchedulerEmployeeEmployeeAdditionalInfoIdDelete: async (employeeAdditionalInfoId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeAdditionalInfoId' is not null or undefined
            assertParamExists('hrSchedulerEmployeeEmployeeAdditionalInfoIdDelete', 'employeeAdditionalInfoId', employeeAdditionalInfoId)
            const localVarPath = `/hr/scheduler-employee/{employeeAdditionalInfoId}`
                .replace(`{${"employeeAdditionalInfoId"}}`, encodeURIComponent(String(employeeAdditionalInfoId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hrV2EmployeeDetailsEmployeeIdStatusGet: async (employeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('hrV2EmployeeDetailsEmployeeIdStatusGet', 'employeeId', employeeId)
            const localVarPath = `/hr/v2/employee-details/{employeeId}/status`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HrApi - functional programming interface
 * @export
 */
export const HrApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HrApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Shows Accruals in FE friendly format
         * @param {number} [employeeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hrAccrualsGet(employeeId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccrualResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hrAccrualsGet(employeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hrAllEmployeesLaborLevelsPut(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hrAllEmployeesLaborLevelsPut(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Disables an employee in the scheduler system based on the provided employee ID.
         * @param {number} employeeId The ID of the employee to disable in the scheduler.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hrEmployeeDetailsEmployeeIdDisablePut(employeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hrEmployeeDetailsEmployeeIdDisablePut(employeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Enables the employee in the scheduler by setting their status to active.
         * @param {number} employeeId The ID of the employee to enable.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hrEmployeeDetailsEmployeeIdEnablePut(employeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hrEmployeeDetailsEmployeeIdEnablePut(employeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieves the scheduler status of a specific employee.
         * @param {number} employeeId The unique identifier of the employee.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async hrEmployeeDetailsEmployeeIdStatusGet(employeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hrEmployeeDetailsEmployeeIdStatusGet(employeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [searchParam] 
         * @param {number} [departmentId] 
         * @param {number} [facilityId] 
         * @param {number} [positionId] 
         * @param {number} [employerId] 
         * @param {number} [employeeId] 
         * @param {boolean} [hasPendingAbsenceRequests] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {boolean} [allowInactive] 
         * @param {boolean} [allowWithoutCellphone] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hrEmployeeDetailsGet(searchParam?: string, departmentId?: number, facilityId?: number, positionId?: number, employerId?: number, employeeId?: number, hasPendingAbsenceRequests?: boolean, pageNumber?: number, pageSize?: number, allowInactive?: boolean, allowWithoutCellphone?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfPageModelOfEmployeeDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hrEmployeeDetailsGet(searchParam, departmentId, facilityId, positionId, employerId, employeeId, hasPendingAbsenceRequests, pageNumber, pageSize, allowInactive, allowWithoutCellphone, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [searchParam] 
         * @param {number} [departmentId] 
         * @param {number} [facilityId] 
         * @param {number} [positionId] 
         * @param {number} [employerId] 
         * @param {number} [employeeId] 
         * @param {boolean} [hasPendingAbsenceRequests] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {boolean} [allowInactive] 
         * @param {boolean} [allowWithoutCellphone] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hrEmployeeDetailsNoPaginationGet(searchParam?: string, departmentId?: number, facilityId?: number, positionId?: number, employerId?: number, employeeId?: number, hasPendingAbsenceRequests?: boolean, pageNumber?: number, pageSize?: number, allowInactive?: boolean, allowWithoutCellphone?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfListOfEmployeeDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hrEmployeeDetailsNoPaginationGet(searchParam, departmentId, facilityId, positionId, employerId, employeeId, hasPendingAbsenceRequests, pageNumber, pageSize, allowInactive, allowWithoutCellphone, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Commits all pending scheduler changes for the specified employee.  This includes status, planned absences, and schedule patterns, and then clears the draft.
         * @param {number} employeeId The ID of the employee whose draft changes should be committed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hrEmployeeIdSavePut(employeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hrEmployeeIdSavePut(employeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Discards all pending scheduler changes for the specified employee, effectively undoing them.  This includes status, planned absences, and schedule patterns.
         * @param {number} employeeId The ID of the employee whose draft changes should be discarded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hrEmployeeIdUndoPut(employeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hrEmployeeIdUndoPut(employeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Updates the employee\'s labor levels in the new scheduler based on TA system data.
         * @param {number} employeeId The PkId of the employee to update.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hrEmployeeLaborLevelsEmployeeIdPut(employeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hrEmployeeLaborLevelsEmployeeIdPut(employeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hrEmployeeScheduleDisabledEmployeeIdGet(employeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ViewEmployeeSchedulePatternDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hrEmployeeScheduleDisabledEmployeeIdGet(employeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hrEmployeeScheduleEmployeeIdGet(employeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfViewEmployeeSchedulePatternDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hrEmployeeScheduleEmployeeIdGet(employeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Validation API used at schedule patterns old screen
         * @param {number} employeeId 
         * @param {UpdateEmployeeSchedulePatternDto} [updateEmployeeSchedulePatternDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hrEmployeeScheduleValidateEmployeeIdPost(employeeId: number, updateEmployeeSchedulePatternDto?: UpdateEmployeeSchedulePatternDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfValidateEmployeeSchedulePatternDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hrEmployeeScheduleValidateEmployeeIdPost(employeeId, updateEmployeeSchedulePatternDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateEmployeeLaborLevelsInNewSchedulerRequest} [updateEmployeeLaborLevelsInNewSchedulerRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hrEmployeesLaborLevelsPut(updateEmployeeLaborLevelsInNewSchedulerRequest?: UpdateEmployeeLaborLevelsInNewSchedulerRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hrEmployeesLaborLevelsPut(updateEmployeeLaborLevelsInNewSchedulerRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} employerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hrEmployerEmployerIdGet(employerId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfViewEmployerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hrEmployerEmployerIdGet(employerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} employerId 
         * @param {UpdateEmployerDto} [updateEmployerDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hrEmployerEmployerIdPut(employerId: number, updateEmployerDto?: UpdateEmployerDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hrEmployerEmployerIdPut(employerId, updateEmployerDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hrEmployerGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfListOfViewEmployerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hrEmployerGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [schedulePeriodId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hrFixIncorrectAssignmentsDueToFailedBuildSchedulesPost(schedulePeriodId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfListOfCreateAssignmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hrFixIncorrectAssignmentsDueToFailedBuildSchedulesPost(schedulePeriodId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hrPositionWithCoverageEmployeeIdGet(employeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfGetEmployeePositionsWithCoverage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hrPositionWithCoverageEmployeeIdGet(employeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Removes employee from scheduler only
         * @param {number} employeeAdditionalInfoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hrSchedulerEmployeeEmployeeAdditionalInfoIdDelete(employeeAdditionalInfoId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hrSchedulerEmployeeEmployeeAdditionalInfoIdDelete(employeeAdditionalInfoId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hrV2EmployeeDetailsEmployeeIdStatusGet(employeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SchedulerTabsVisibilityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hrV2EmployeeDetailsEmployeeIdStatusGet(employeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * HrApi - factory interface
 * @export
 */
export const HrApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HrApiFp(configuration)
    return {
        /**
         * 
         * @summary Shows Accruals in FE friendly format
         * @param {HrApiHrAccrualsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hrAccrualsGet(requestParameters: HrApiHrAccrualsGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<AccrualResponse> {
            return localVarFp.hrAccrualsGet(requestParameters.employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hrAllEmployeesLaborLevelsPut(options?: AxiosRequestConfig): AxiosPromise<BaseResponse> {
            return localVarFp.hrAllEmployeesLaborLevelsPut(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Disables an employee in the scheduler system based on the provided employee ID.
         * @param {HrApiHrEmployeeDetailsEmployeeIdDisablePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hrEmployeeDetailsEmployeeIdDisablePut(requestParameters: HrApiHrEmployeeDetailsEmployeeIdDisablePutRequest, options?: AxiosRequestConfig): AxiosPromise<BaseResponse> {
            return localVarFp.hrEmployeeDetailsEmployeeIdDisablePut(requestParameters.employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Enables the employee in the scheduler by setting their status to active.
         * @param {HrApiHrEmployeeDetailsEmployeeIdEnablePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hrEmployeeDetailsEmployeeIdEnablePut(requestParameters: HrApiHrEmployeeDetailsEmployeeIdEnablePutRequest, options?: AxiosRequestConfig): AxiosPromise<BaseResponse> {
            return localVarFp.hrEmployeeDetailsEmployeeIdEnablePut(requestParameters.employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves the scheduler status of a specific employee.
         * @param {HrApiHrEmployeeDetailsEmployeeIdStatusGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        hrEmployeeDetailsEmployeeIdStatusGet(requestParameters: HrApiHrEmployeeDetailsEmployeeIdStatusGetRequest, options?: AxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.hrEmployeeDetailsEmployeeIdStatusGet(requestParameters.employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {HrApiHrEmployeeDetailsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hrEmployeeDetailsGet(requestParameters: HrApiHrEmployeeDetailsGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfPageModelOfEmployeeDetailsResponse> {
            return localVarFp.hrEmployeeDetailsGet(requestParameters.searchParam, requestParameters.departmentId, requestParameters.facilityId, requestParameters.positionId, requestParameters.employerId, requestParameters.employeeId, requestParameters.hasPendingAbsenceRequests, requestParameters.pageNumber, requestParameters.pageSize, requestParameters.allowInactive, requestParameters.allowWithoutCellphone, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {HrApiHrEmployeeDetailsNoPaginationGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hrEmployeeDetailsNoPaginationGet(requestParameters: HrApiHrEmployeeDetailsNoPaginationGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfListOfEmployeeDetailsResponse> {
            return localVarFp.hrEmployeeDetailsNoPaginationGet(requestParameters.searchParam, requestParameters.departmentId, requestParameters.facilityId, requestParameters.positionId, requestParameters.employerId, requestParameters.employeeId, requestParameters.hasPendingAbsenceRequests, requestParameters.pageNumber, requestParameters.pageSize, requestParameters.allowInactive, requestParameters.allowWithoutCellphone, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Commits all pending scheduler changes for the specified employee.  This includes status, planned absences, and schedule patterns, and then clears the draft.
         * @param {HrApiHrEmployeeIdSavePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hrEmployeeIdSavePut(requestParameters: HrApiHrEmployeeIdSavePutRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.hrEmployeeIdSavePut(requestParameters.employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Discards all pending scheduler changes for the specified employee, effectively undoing them.  This includes status, planned absences, and schedule patterns.
         * @param {HrApiHrEmployeeIdUndoPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hrEmployeeIdUndoPut(requestParameters: HrApiHrEmployeeIdUndoPutRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.hrEmployeeIdUndoPut(requestParameters.employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates the employee\'s labor levels in the new scheduler based on TA system data.
         * @param {HrApiHrEmployeeLaborLevelsEmployeeIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hrEmployeeLaborLevelsEmployeeIdPut(requestParameters: HrApiHrEmployeeLaborLevelsEmployeeIdPutRequest, options?: AxiosRequestConfig): AxiosPromise<BaseResponse> {
            return localVarFp.hrEmployeeLaborLevelsEmployeeIdPut(requestParameters.employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {HrApiHrEmployeeScheduleDisabledEmployeeIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hrEmployeeScheduleDisabledEmployeeIdGet(requestParameters: HrApiHrEmployeeScheduleDisabledEmployeeIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<ViewEmployeeSchedulePatternDto> {
            return localVarFp.hrEmployeeScheduleDisabledEmployeeIdGet(requestParameters.employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {HrApiHrEmployeeScheduleEmployeeIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hrEmployeeScheduleEmployeeIdGet(requestParameters: HrApiHrEmployeeScheduleEmployeeIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfViewEmployeeSchedulePatternDto> {
            return localVarFp.hrEmployeeScheduleEmployeeIdGet(requestParameters.employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Validation API used at schedule patterns old screen
         * @param {HrApiHrEmployeeScheduleValidateEmployeeIdPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hrEmployeeScheduleValidateEmployeeIdPost(requestParameters: HrApiHrEmployeeScheduleValidateEmployeeIdPostRequest, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfValidateEmployeeSchedulePatternDTO> {
            return localVarFp.hrEmployeeScheduleValidateEmployeeIdPost(requestParameters.employeeId, requestParameters.updateEmployeeSchedulePatternDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {HrApiHrEmployeesLaborLevelsPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hrEmployeesLaborLevelsPut(requestParameters: HrApiHrEmployeesLaborLevelsPutRequest = {}, options?: AxiosRequestConfig): AxiosPromise<BaseResponse> {
            return localVarFp.hrEmployeesLaborLevelsPut(requestParameters.updateEmployeeLaborLevelsInNewSchedulerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {HrApiHrEmployerEmployerIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hrEmployerEmployerIdGet(requestParameters: HrApiHrEmployerEmployerIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfViewEmployerDto> {
            return localVarFp.hrEmployerEmployerIdGet(requestParameters.employerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {HrApiHrEmployerEmployerIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hrEmployerEmployerIdPut(requestParameters: HrApiHrEmployerEmployerIdPutRequest, options?: AxiosRequestConfig): AxiosPromise<BaseResponse> {
            return localVarFp.hrEmployerEmployerIdPut(requestParameters.employerId, requestParameters.updateEmployerDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hrEmployerGet(options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfListOfViewEmployerDto> {
            return localVarFp.hrEmployerGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {HrApiHrFixIncorrectAssignmentsDueToFailedBuildSchedulesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hrFixIncorrectAssignmentsDueToFailedBuildSchedulesPost(requestParameters: HrApiHrFixIncorrectAssignmentsDueToFailedBuildSchedulesPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfListOfCreateAssignmentDto> {
            return localVarFp.hrFixIncorrectAssignmentsDueToFailedBuildSchedulesPost(requestParameters.schedulePeriodId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {HrApiHrPositionWithCoverageEmployeeIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hrPositionWithCoverageEmployeeIdGet(requestParameters: HrApiHrPositionWithCoverageEmployeeIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfGetEmployeePositionsWithCoverage> {
            return localVarFp.hrPositionWithCoverageEmployeeIdGet(requestParameters.employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Removes employee from scheduler only
         * @param {HrApiHrSchedulerEmployeeEmployeeAdditionalInfoIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hrSchedulerEmployeeEmployeeAdditionalInfoIdDelete(requestParameters: HrApiHrSchedulerEmployeeEmployeeAdditionalInfoIdDeleteRequest, options?: AxiosRequestConfig): AxiosPromise<BaseResponse> {
            return localVarFp.hrSchedulerEmployeeEmployeeAdditionalInfoIdDelete(requestParameters.employeeAdditionalInfoId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {HrApiHrV2EmployeeDetailsEmployeeIdStatusGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hrV2EmployeeDetailsEmployeeIdStatusGet(requestParameters: HrApiHrV2EmployeeDetailsEmployeeIdStatusGetRequest, options?: AxiosRequestConfig): AxiosPromise<SchedulerTabsVisibilityResponse> {
            return localVarFp.hrV2EmployeeDetailsEmployeeIdStatusGet(requestParameters.employeeId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for hrAccrualsGet operation in HrApi.
 * @export
 * @interface HrApiHrAccrualsGetRequest
 */
export interface HrApiHrAccrualsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof HrApiHrAccrualsGet
     */
    readonly employeeId?: number
}

/**
 * Request parameters for hrEmployeeDetailsEmployeeIdDisablePut operation in HrApi.
 * @export
 * @interface HrApiHrEmployeeDetailsEmployeeIdDisablePutRequest
 */
export interface HrApiHrEmployeeDetailsEmployeeIdDisablePutRequest {
    /**
     * The ID of the employee to disable in the scheduler.
     * @type {number}
     * @memberof HrApiHrEmployeeDetailsEmployeeIdDisablePut
     */
    readonly employeeId: number
}

/**
 * Request parameters for hrEmployeeDetailsEmployeeIdEnablePut operation in HrApi.
 * @export
 * @interface HrApiHrEmployeeDetailsEmployeeIdEnablePutRequest
 */
export interface HrApiHrEmployeeDetailsEmployeeIdEnablePutRequest {
    /**
     * The ID of the employee to enable.
     * @type {number}
     * @memberof HrApiHrEmployeeDetailsEmployeeIdEnablePut
     */
    readonly employeeId: number
}

/**
 * Request parameters for hrEmployeeDetailsEmployeeIdStatusGet operation in HrApi.
 * @export
 * @interface HrApiHrEmployeeDetailsEmployeeIdStatusGetRequest
 */
export interface HrApiHrEmployeeDetailsEmployeeIdStatusGetRequest {
    /**
     * The unique identifier of the employee.
     * @type {number}
     * @memberof HrApiHrEmployeeDetailsEmployeeIdStatusGet
     */
    readonly employeeId: number
}

/**
 * Request parameters for hrEmployeeDetailsGet operation in HrApi.
 * @export
 * @interface HrApiHrEmployeeDetailsGetRequest
 */
export interface HrApiHrEmployeeDetailsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof HrApiHrEmployeeDetailsGet
     */
    readonly searchParam?: string

    /**
     * 
     * @type {number}
     * @memberof HrApiHrEmployeeDetailsGet
     */
    readonly departmentId?: number

    /**
     * 
     * @type {number}
     * @memberof HrApiHrEmployeeDetailsGet
     */
    readonly facilityId?: number

    /**
     * 
     * @type {number}
     * @memberof HrApiHrEmployeeDetailsGet
     */
    readonly positionId?: number

    /**
     * 
     * @type {number}
     * @memberof HrApiHrEmployeeDetailsGet
     */
    readonly employerId?: number

    /**
     * 
     * @type {number}
     * @memberof HrApiHrEmployeeDetailsGet
     */
    readonly employeeId?: number

    /**
     * 
     * @type {boolean}
     * @memberof HrApiHrEmployeeDetailsGet
     */
    readonly hasPendingAbsenceRequests?: boolean

    /**
     * 
     * @type {number}
     * @memberof HrApiHrEmployeeDetailsGet
     */
    readonly pageNumber?: number

    /**
     * 
     * @type {number}
     * @memberof HrApiHrEmployeeDetailsGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {boolean}
     * @memberof HrApiHrEmployeeDetailsGet
     */
    readonly allowInactive?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof HrApiHrEmployeeDetailsGet
     */
    readonly allowWithoutCellphone?: boolean
}

/**
 * Request parameters for hrEmployeeDetailsNoPaginationGet operation in HrApi.
 * @export
 * @interface HrApiHrEmployeeDetailsNoPaginationGetRequest
 */
export interface HrApiHrEmployeeDetailsNoPaginationGetRequest {
    /**
     * 
     * @type {string}
     * @memberof HrApiHrEmployeeDetailsNoPaginationGet
     */
    readonly searchParam?: string

    /**
     * 
     * @type {number}
     * @memberof HrApiHrEmployeeDetailsNoPaginationGet
     */
    readonly departmentId?: number

    /**
     * 
     * @type {number}
     * @memberof HrApiHrEmployeeDetailsNoPaginationGet
     */
    readonly facilityId?: number

    /**
     * 
     * @type {number}
     * @memberof HrApiHrEmployeeDetailsNoPaginationGet
     */
    readonly positionId?: number

    /**
     * 
     * @type {number}
     * @memberof HrApiHrEmployeeDetailsNoPaginationGet
     */
    readonly employerId?: number

    /**
     * 
     * @type {number}
     * @memberof HrApiHrEmployeeDetailsNoPaginationGet
     */
    readonly employeeId?: number

    /**
     * 
     * @type {boolean}
     * @memberof HrApiHrEmployeeDetailsNoPaginationGet
     */
    readonly hasPendingAbsenceRequests?: boolean

    /**
     * 
     * @type {number}
     * @memberof HrApiHrEmployeeDetailsNoPaginationGet
     */
    readonly pageNumber?: number

    /**
     * 
     * @type {number}
     * @memberof HrApiHrEmployeeDetailsNoPaginationGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {boolean}
     * @memberof HrApiHrEmployeeDetailsNoPaginationGet
     */
    readonly allowInactive?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof HrApiHrEmployeeDetailsNoPaginationGet
     */
    readonly allowWithoutCellphone?: boolean
}

/**
 * Request parameters for hrEmployeeIdSavePut operation in HrApi.
 * @export
 * @interface HrApiHrEmployeeIdSavePutRequest
 */
export interface HrApiHrEmployeeIdSavePutRequest {
    /**
     * The ID of the employee whose draft changes should be committed.
     * @type {number}
     * @memberof HrApiHrEmployeeIdSavePut
     */
    readonly employeeId: number
}

/**
 * Request parameters for hrEmployeeIdUndoPut operation in HrApi.
 * @export
 * @interface HrApiHrEmployeeIdUndoPutRequest
 */
export interface HrApiHrEmployeeIdUndoPutRequest {
    /**
     * The ID of the employee whose draft changes should be discarded.
     * @type {number}
     * @memberof HrApiHrEmployeeIdUndoPut
     */
    readonly employeeId: number
}

/**
 * Request parameters for hrEmployeeLaborLevelsEmployeeIdPut operation in HrApi.
 * @export
 * @interface HrApiHrEmployeeLaborLevelsEmployeeIdPutRequest
 */
export interface HrApiHrEmployeeLaborLevelsEmployeeIdPutRequest {
    /**
     * The PkId of the employee to update.
     * @type {number}
     * @memberof HrApiHrEmployeeLaborLevelsEmployeeIdPut
     */
    readonly employeeId: number
}

/**
 * Request parameters for hrEmployeeScheduleDisabledEmployeeIdGet operation in HrApi.
 * @export
 * @interface HrApiHrEmployeeScheduleDisabledEmployeeIdGetRequest
 */
export interface HrApiHrEmployeeScheduleDisabledEmployeeIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof HrApiHrEmployeeScheduleDisabledEmployeeIdGet
     */
    readonly employeeId: number
}

/**
 * Request parameters for hrEmployeeScheduleEmployeeIdGet operation in HrApi.
 * @export
 * @interface HrApiHrEmployeeScheduleEmployeeIdGetRequest
 */
export interface HrApiHrEmployeeScheduleEmployeeIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof HrApiHrEmployeeScheduleEmployeeIdGet
     */
    readonly employeeId: number
}

/**
 * Request parameters for hrEmployeeScheduleValidateEmployeeIdPost operation in HrApi.
 * @export
 * @interface HrApiHrEmployeeScheduleValidateEmployeeIdPostRequest
 */
export interface HrApiHrEmployeeScheduleValidateEmployeeIdPostRequest {
    /**
     * 
     * @type {number}
     * @memberof HrApiHrEmployeeScheduleValidateEmployeeIdPost
     */
    readonly employeeId: number

    /**
     * 
     * @type {UpdateEmployeeSchedulePatternDto}
     * @memberof HrApiHrEmployeeScheduleValidateEmployeeIdPost
     */
    readonly updateEmployeeSchedulePatternDto?: UpdateEmployeeSchedulePatternDto
}

/**
 * Request parameters for hrEmployeesLaborLevelsPut operation in HrApi.
 * @export
 * @interface HrApiHrEmployeesLaborLevelsPutRequest
 */
export interface HrApiHrEmployeesLaborLevelsPutRequest {
    /**
     * 
     * @type {UpdateEmployeeLaborLevelsInNewSchedulerRequest}
     * @memberof HrApiHrEmployeesLaborLevelsPut
     */
    readonly updateEmployeeLaborLevelsInNewSchedulerRequest?: UpdateEmployeeLaborLevelsInNewSchedulerRequest
}

/**
 * Request parameters for hrEmployerEmployerIdGet operation in HrApi.
 * @export
 * @interface HrApiHrEmployerEmployerIdGetRequest
 */
export interface HrApiHrEmployerEmployerIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof HrApiHrEmployerEmployerIdGet
     */
    readonly employerId: number
}

/**
 * Request parameters for hrEmployerEmployerIdPut operation in HrApi.
 * @export
 * @interface HrApiHrEmployerEmployerIdPutRequest
 */
export interface HrApiHrEmployerEmployerIdPutRequest {
    /**
     * 
     * @type {number}
     * @memberof HrApiHrEmployerEmployerIdPut
     */
    readonly employerId: number

    /**
     * 
     * @type {UpdateEmployerDto}
     * @memberof HrApiHrEmployerEmployerIdPut
     */
    readonly updateEmployerDto?: UpdateEmployerDto
}

/**
 * Request parameters for hrFixIncorrectAssignmentsDueToFailedBuildSchedulesPost operation in HrApi.
 * @export
 * @interface HrApiHrFixIncorrectAssignmentsDueToFailedBuildSchedulesPostRequest
 */
export interface HrApiHrFixIncorrectAssignmentsDueToFailedBuildSchedulesPostRequest {
    /**
     * 
     * @type {number}
     * @memberof HrApiHrFixIncorrectAssignmentsDueToFailedBuildSchedulesPost
     */
    readonly schedulePeriodId?: number
}

/**
 * Request parameters for hrPositionWithCoverageEmployeeIdGet operation in HrApi.
 * @export
 * @interface HrApiHrPositionWithCoverageEmployeeIdGetRequest
 */
export interface HrApiHrPositionWithCoverageEmployeeIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof HrApiHrPositionWithCoverageEmployeeIdGet
     */
    readonly employeeId: number
}

/**
 * Request parameters for hrSchedulerEmployeeEmployeeAdditionalInfoIdDelete operation in HrApi.
 * @export
 * @interface HrApiHrSchedulerEmployeeEmployeeAdditionalInfoIdDeleteRequest
 */
export interface HrApiHrSchedulerEmployeeEmployeeAdditionalInfoIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof HrApiHrSchedulerEmployeeEmployeeAdditionalInfoIdDelete
     */
    readonly employeeAdditionalInfoId: number
}

/**
 * Request parameters for hrV2EmployeeDetailsEmployeeIdStatusGet operation in HrApi.
 * @export
 * @interface HrApiHrV2EmployeeDetailsEmployeeIdStatusGetRequest
 */
export interface HrApiHrV2EmployeeDetailsEmployeeIdStatusGetRequest {
    /**
     * 
     * @type {number}
     * @memberof HrApiHrV2EmployeeDetailsEmployeeIdStatusGet
     */
    readonly employeeId: number
}

/**
 * HrApi - object-oriented interface
 * @export
 * @class HrApi
 * @extends {BaseAPI}
 */
export class HrApi extends BaseAPI {
    /**
     * 
     * @summary Shows Accruals in FE friendly format
     * @param {HrApiHrAccrualsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HrApi
     */
    public hrAccrualsGet(requestParameters: HrApiHrAccrualsGetRequest = {}, options?: AxiosRequestConfig) {
        return HrApiFp(this.configuration).hrAccrualsGet(requestParameters.employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HrApi
     */
    public hrAllEmployeesLaborLevelsPut(options?: AxiosRequestConfig) {
        return HrApiFp(this.configuration).hrAllEmployeesLaborLevelsPut(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Disables an employee in the scheduler system based on the provided employee ID.
     * @param {HrApiHrEmployeeDetailsEmployeeIdDisablePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HrApi
     */
    public hrEmployeeDetailsEmployeeIdDisablePut(requestParameters: HrApiHrEmployeeDetailsEmployeeIdDisablePutRequest, options?: AxiosRequestConfig) {
        return HrApiFp(this.configuration).hrEmployeeDetailsEmployeeIdDisablePut(requestParameters.employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Enables the employee in the scheduler by setting their status to active.
     * @param {HrApiHrEmployeeDetailsEmployeeIdEnablePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HrApi
     */
    public hrEmployeeDetailsEmployeeIdEnablePut(requestParameters: HrApiHrEmployeeDetailsEmployeeIdEnablePutRequest, options?: AxiosRequestConfig) {
        return HrApiFp(this.configuration).hrEmployeeDetailsEmployeeIdEnablePut(requestParameters.employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves the scheduler status of a specific employee.
     * @param {HrApiHrEmployeeDetailsEmployeeIdStatusGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof HrApi
     */
    public hrEmployeeDetailsEmployeeIdStatusGet(requestParameters: HrApiHrEmployeeDetailsEmployeeIdStatusGetRequest, options?: AxiosRequestConfig) {
        return HrApiFp(this.configuration).hrEmployeeDetailsEmployeeIdStatusGet(requestParameters.employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {HrApiHrEmployeeDetailsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HrApi
     */
    public hrEmployeeDetailsGet(requestParameters: HrApiHrEmployeeDetailsGetRequest = {}, options?: AxiosRequestConfig) {
        return HrApiFp(this.configuration).hrEmployeeDetailsGet(requestParameters.searchParam, requestParameters.departmentId, requestParameters.facilityId, requestParameters.positionId, requestParameters.employerId, requestParameters.employeeId, requestParameters.hasPendingAbsenceRequests, requestParameters.pageNumber, requestParameters.pageSize, requestParameters.allowInactive, requestParameters.allowWithoutCellphone, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {HrApiHrEmployeeDetailsNoPaginationGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HrApi
     */
    public hrEmployeeDetailsNoPaginationGet(requestParameters: HrApiHrEmployeeDetailsNoPaginationGetRequest = {}, options?: AxiosRequestConfig) {
        return HrApiFp(this.configuration).hrEmployeeDetailsNoPaginationGet(requestParameters.searchParam, requestParameters.departmentId, requestParameters.facilityId, requestParameters.positionId, requestParameters.employerId, requestParameters.employeeId, requestParameters.hasPendingAbsenceRequests, requestParameters.pageNumber, requestParameters.pageSize, requestParameters.allowInactive, requestParameters.allowWithoutCellphone, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Commits all pending scheduler changes for the specified employee.  This includes status, planned absences, and schedule patterns, and then clears the draft.
     * @param {HrApiHrEmployeeIdSavePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HrApi
     */
    public hrEmployeeIdSavePut(requestParameters: HrApiHrEmployeeIdSavePutRequest, options?: AxiosRequestConfig) {
        return HrApiFp(this.configuration).hrEmployeeIdSavePut(requestParameters.employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Discards all pending scheduler changes for the specified employee, effectively undoing them.  This includes status, planned absences, and schedule patterns.
     * @param {HrApiHrEmployeeIdUndoPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HrApi
     */
    public hrEmployeeIdUndoPut(requestParameters: HrApiHrEmployeeIdUndoPutRequest, options?: AxiosRequestConfig) {
        return HrApiFp(this.configuration).hrEmployeeIdUndoPut(requestParameters.employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates the employee\'s labor levels in the new scheduler based on TA system data.
     * @param {HrApiHrEmployeeLaborLevelsEmployeeIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HrApi
     */
    public hrEmployeeLaborLevelsEmployeeIdPut(requestParameters: HrApiHrEmployeeLaborLevelsEmployeeIdPutRequest, options?: AxiosRequestConfig) {
        return HrApiFp(this.configuration).hrEmployeeLaborLevelsEmployeeIdPut(requestParameters.employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {HrApiHrEmployeeScheduleDisabledEmployeeIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HrApi
     */
    public hrEmployeeScheduleDisabledEmployeeIdGet(requestParameters: HrApiHrEmployeeScheduleDisabledEmployeeIdGetRequest, options?: AxiosRequestConfig) {
        return HrApiFp(this.configuration).hrEmployeeScheduleDisabledEmployeeIdGet(requestParameters.employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {HrApiHrEmployeeScheduleEmployeeIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HrApi
     */
    public hrEmployeeScheduleEmployeeIdGet(requestParameters: HrApiHrEmployeeScheduleEmployeeIdGetRequest, options?: AxiosRequestConfig) {
        return HrApiFp(this.configuration).hrEmployeeScheduleEmployeeIdGet(requestParameters.employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Validation API used at schedule patterns old screen
     * @param {HrApiHrEmployeeScheduleValidateEmployeeIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HrApi
     */
    public hrEmployeeScheduleValidateEmployeeIdPost(requestParameters: HrApiHrEmployeeScheduleValidateEmployeeIdPostRequest, options?: AxiosRequestConfig) {
        return HrApiFp(this.configuration).hrEmployeeScheduleValidateEmployeeIdPost(requestParameters.employeeId, requestParameters.updateEmployeeSchedulePatternDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {HrApiHrEmployeesLaborLevelsPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HrApi
     */
    public hrEmployeesLaborLevelsPut(requestParameters: HrApiHrEmployeesLaborLevelsPutRequest = {}, options?: AxiosRequestConfig) {
        return HrApiFp(this.configuration).hrEmployeesLaborLevelsPut(requestParameters.updateEmployeeLaborLevelsInNewSchedulerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {HrApiHrEmployerEmployerIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HrApi
     */
    public hrEmployerEmployerIdGet(requestParameters: HrApiHrEmployerEmployerIdGetRequest, options?: AxiosRequestConfig) {
        return HrApiFp(this.configuration).hrEmployerEmployerIdGet(requestParameters.employerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {HrApiHrEmployerEmployerIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HrApi
     */
    public hrEmployerEmployerIdPut(requestParameters: HrApiHrEmployerEmployerIdPutRequest, options?: AxiosRequestConfig) {
        return HrApiFp(this.configuration).hrEmployerEmployerIdPut(requestParameters.employerId, requestParameters.updateEmployerDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HrApi
     */
    public hrEmployerGet(options?: AxiosRequestConfig) {
        return HrApiFp(this.configuration).hrEmployerGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {HrApiHrFixIncorrectAssignmentsDueToFailedBuildSchedulesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HrApi
     */
    public hrFixIncorrectAssignmentsDueToFailedBuildSchedulesPost(requestParameters: HrApiHrFixIncorrectAssignmentsDueToFailedBuildSchedulesPostRequest = {}, options?: AxiosRequestConfig) {
        return HrApiFp(this.configuration).hrFixIncorrectAssignmentsDueToFailedBuildSchedulesPost(requestParameters.schedulePeriodId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {HrApiHrPositionWithCoverageEmployeeIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HrApi
     */
    public hrPositionWithCoverageEmployeeIdGet(requestParameters: HrApiHrPositionWithCoverageEmployeeIdGetRequest, options?: AxiosRequestConfig) {
        return HrApiFp(this.configuration).hrPositionWithCoverageEmployeeIdGet(requestParameters.employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Removes employee from scheduler only
     * @param {HrApiHrSchedulerEmployeeEmployeeAdditionalInfoIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HrApi
     */
    public hrSchedulerEmployeeEmployeeAdditionalInfoIdDelete(requestParameters: HrApiHrSchedulerEmployeeEmployeeAdditionalInfoIdDeleteRequest, options?: AxiosRequestConfig) {
        return HrApiFp(this.configuration).hrSchedulerEmployeeEmployeeAdditionalInfoIdDelete(requestParameters.employeeAdditionalInfoId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {HrApiHrV2EmployeeDetailsEmployeeIdStatusGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HrApi
     */
    public hrV2EmployeeDetailsEmployeeIdStatusGet(requestParameters: HrApiHrV2EmployeeDetailsEmployeeIdStatusGetRequest, options?: AxiosRequestConfig) {
        return HrApiFp(this.configuration).hrV2EmployeeDetailsEmployeeIdStatusGet(requestParameters.employeeId, options).then((request) => request(this.axios, this.basePath));
    }
}
